function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import React from 'react';
import { Radio } from '../../../../Reviews/Forms/Radio';
import { Checkbox } from '../../../../Reviews/Forms/Checkbox';
import { isOptionChecked } from '../../utils';
import { CheckboxItem, CheckboxLabel, CheckboxCounter, CheckboxItemsInner } from './partials';
var searchFilter = function searchFilter(option, search, value, alwaysShowChecked) {
  return option.label.toLowerCase().includes(search.toLowerCase()) || alwaysShowChecked && isOptionChecked(option, value);
};
export var CheckboxItems = function CheckboxItems(_ref) {
  var _ref$filterSearchResu = _ref.filterSearchResults,
    filterSearchResults = _ref$filterSearchResu === void 0 ? true : _ref$filterSearchResu,
    _ref$maxIsFilled = _ref.maxIsFilled,
    maxIsFilled = _ref$maxIsFilled === void 0 ? false : _ref$maxIsFilled,
    _ref$alwaysShowChecke = _ref.alwaysShowChecked,
    alwaysShowChecked = _ref$alwaysShowChecke === void 0 ? true : _ref$alwaysShowChecke,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    options = _ref.options,
    value = _ref.value,
    search = _ref.search,
    onCheckboxChange = _ref.onCheckboxChange,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$reorderOptions = _ref.reorderOptions,
    reorderOptions = _ref$reorderOptions === void 0 ? false : _ref$reorderOptions,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? null : _ref$height;
  var handleCheckboxChange = onCheckboxChange ? onCheckboxChange : function () {};
  var getCheckboxOptions = function getCheckboxOptions() {
    var leadingOptions = options.filter(function (option) {
      return isOptionChecked(option, value);
    });
    var trailingOptions = options.filter(function (option) {
      return !isOptionChecked(option, value);
    });
    var orderedOptions = reorderOptions ? [].concat(_toConsumableArray(leadingOptions), _toConsumableArray(trailingOptions)) : options;
    return orderedOptions.filter(function (option) {
      return !filterSearchResults || filterSearchResults && searchFilter(option, search, value, alwaysShowChecked);
    });
  };
  var showingOptions = getCheckboxOptions();
  if (multiple) {
    return React.createElement(CheckboxItemsInner, {
      scrollable: true,
      height: height
    }, showingOptions.map(function (option) {
      return React.createElement(Checkbox, {
        disabled: maxIsFilled && !isOptionChecked(option, value),
        key: "option-".concat(option.id, "-").concat(option.label),
        id: "option-".concat(option.id, "-").concat(option.label),
        name: option.id,
        value: "checked",
        handleChange: handleCheckboxChange,
        required: false,
        checked: isOptionChecked(option, value)
      }, React.createElement(CheckboxItem, {
        fullWidth: fullWidth
      }, React.createElement(CheckboxLabel, null, option.label), React.createElement(CheckboxCounter, null, option.counter)));
    }));
  }
  return React.createElement(CheckboxItemsInner, {
    scrollable: true
  }, showingOptions.map(function (option) {
    return React.createElement(Radio, {
      key: option.id,
      id: "option".concat(option.id),
      name: option.id,
      value: "checked",
      handleChange: handleCheckboxChange,
      required: false,
      checked: isOptionChecked(option, value)
    }, React.createElement(CheckboxItem, {
      fullWidth: fullWidth
    }, React.createElement(CheckboxLabel, null, option.label), React.createElement(CheckboxCounter, null, option.counter)));
  }));
};